import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
export default function Signup() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: ''
  });
  const navigate = useNavigate();
  const handleSignupClick = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_URL}/api/auth/signup`, {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        password: formData.password
      });

      console.log('Signup successful:', response.data);
      // You can redirect user or show a success message here
      if (response.data.success) {
        //step 1: store the auth token
        localStorage.setItem('authToken', response.data.token);
        localStorage.setItem('userName', response.data.user.name);
        localStorage.setItem('userEmail', response.data.user.email);
        localStorage.setItem('userPhone', response.data.user.phone);
        localStorage.setItem('userRole', response.data.user.role);
        localStorage.setItem('userUsedCodes', JSON.stringify(response.data.user.userCodes));
        //step 2: redirect the user to dashboard/home page
        navigate('/Verify-Email-OTP');
      }
    } catch (error) {
      if (error.response) {
        alert("Signup failed: " + error.response.data.message);
      } else {
        console.error("Error:", error.message);
        alert("Something went wrong. Please try again.");
      }
    }

  };
  return (
    <>
      <form className='form' action="#">
        <h2>Sign Up</h2>
        <label htmlFor="name">Name:</label>
        <input type="text" onChange={(e) => setFormData({ ...formData, name: e.target.value })} id="name" name="name" placeholder='Your Name Here' required />
        <label htmlFor="email">Email:</label>
        <input type="email" onChange={(e) => setFormData({ ...formData, email: e.target.value })} id="email" name="email" placeholder='Email' required />
        <label htmlFor="phone-number">Phone Number:</label>
        <input type="tel" onChange={(e) => setFormData({ ...formData, phone: e.target.value })} id="phone-number" name="phone-number" placeholder='Phone Number' required />
        <label htmlFor="password">Password:</label>
        <input type="password" onChange={(e) => setFormData({ ...formData, password: e.target.value })} id="password" name="password" placeholder='Password' required />
        <button type="submit" onClick={handleSignupClick}>Sign Up</button>
        <p>Already Have An Account? <button type="button" className="link-button-login" onClick={() => navigate("/Log-In")}> LOG IN</button> </p>
      </form>
    </>
  )
}